module.exports = __webpack_public_path__ + "img/pr-2.31812922.png";